import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
  en: {
    translation: {
      common: {
        welcome: 'Welcome',
        login: 'Login',
        logout: 'Logout',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        search: 'Search',
        filter: 'Filter',
        loading: 'Loading...',
        error: 'An error occurred',
      },
      auth: {
        phoneNumber: 'Phone Number',
        password: 'Password',
        loginButton: 'Sign In',
        loginError: 'Invalid credentials',
      },
    },
  },
  vi: {
    translation: {
      common: {
        welcome: 'Chào mừng',
        login: 'Đăng nhập',
        logout: 'Đăng xuất',
        save: 'Lưu',
        cancel: 'Hủy',
        delete: 'Xóa',
        edit: 'Sửa',
        search: 'Tìm kiếm',
        filter: 'Lọc',
        loading: 'Đang tải...',
        error: 'Đã xảy ra lỗi',
      },
      auth: {
        phoneNumber: 'Số điện thoại',
        password: 'Mật khẩu',
        loginButton: 'Đăng nhập',
        loginError: 'Thông tin đăng nhập không hợp lệ',
      },
    },
  },
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'vi', // Default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
